<template>
  <div :class="$style.container">
    <TabList
      :activeTab="activeTabIndex"
      :class="$style.tabList"
      :customActiveTabStyle="$style.activeTab"
      :customContainerStyle="$style.tabListContainer"
      :customNavStyle="$style.tabNav"
      :customTabStyle="$style.tabLink"
      :tabs="tabs"
      @active-tab-change="handleActiveTabChange"
    />
  </div>
</template>

<script>
import {
  ItemTypeConsts,
  StoreModuleMap,
} from 'client/util/Constants';
import { mapGetters, mapState } from 'vuex';
import PolicyGroupTemplates from 'client/groups/Configuration/PolicyGroupTemplates.vue';
import TabList from 'client/components/TabList/TabList.vue';

const settingsModule = StoreModuleMap[ItemTypeConsts.settings];

export default {
  name: 'PolicyGroupTemplateGalleryMainPanel',

  components: {
    TabList,
  },

  props: {
    initialTabIndex: {
      type: Number,
      default: 0,
    },
  },

  data: () => ({
    activeTabIndex: 0,
  }),

  computed: {
    ...mapGetters(settingsModule, [
      'isProvider',
    ]),

    ...mapState(settingsModule, [
      'user',
    ]),

    tabs() {
      const viewTabs = [
        {
          title: 'Recommended Templates',
          component: PolicyGroupTemplates,
          componentProps: {
            itemType: ItemTypeConsts.defaultPolicyGroupTemplates,
          },
        },
      ];

      // If the Admin is an MSP Admin, add in the Custom policy group templates
      // tab.
      if (this.isProvider) {
        viewTabs.unshift({
          title: 'Custom Policy Group Templates',
          component: PolicyGroupTemplates,
          componentProps: {
            itemType: ItemTypeConsts.customPolicyGroupTemplates,
            providerId: this.user.provider,
            sortFields: ['name'],
          },
        });
      }

      return viewTabs;
    },
  },

  beforeMount() {
    this.activeTabIndex = this.initialTabIndex ? this.initialTabIndex : 0;
  },

  methods: {
    handleActiveTabChange(tabIndex) {
      this.activeTabIndex = tabIndex;
    },
  },
};
</script>

<style module>
.container {
  height: 100%;
}

.activeTab a {
  border-bottom: 2px solid var(--jcPrimary);
  color: var(--jcGrey600);
}

.tabList {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.tabListContainer {
  transition: none;
}

.tabLink {
  color: var(--jcGrey);
  font-size: 1.2rem;
  font-weight: bold;
  padding-bottom: 4px;
}

.tabNav {
  margin: 20px 0 10px 20px;
}
</style>
